<template>
  <div class="conversations">
    <div class="contact-left">

      <div class="contact-list-title">群组</div>
      <div class="group-type-box">
        <div @click="getGroupList(0)" :class="{ active: active == 0 }">减重</div>
        <div @click="getGroupList(1)" :class="{ active: active == 1 }">肿瘤</div>
      </div>
      <div class="group-list">
        <div v-for="(group, key) in groups || []" :key="key" class="group-item"
          :class="{ actived: currentGroup?.id === group.id }" @click="groupChat(group, key)">
          <div class="group-avatar">
            <img :src="group.url" />
            <div v-if="group.unread > 0" class="unread-count">
              <span class="unread">{{ group.unread }}</span>
            </div>
          </div>
          <div class="group-name">
            {{ group.name.length > 11 ? group.name.substr(0, 10) + "..." : group.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="chat" v-if="currentGroup">
      <router-view :key="$route.params.id" />
    </div>
    <div class="empty-box" v-if="showEmpty">当前无消息群组</div>
  </div>
</template>

<script>
import restApi from "../api/restapi";
import { formatDate } from '../utils/utils.js'

export default {
  name: 'Conversations',
  data() {
    return {
      showEmpty: false,
      active: 0,
      groups: [],
      currentGroup: null,
      currentUser: {},
      conversations: [],
      conversationIds: [],
      // Conversation右键菜单
      rightClickMenu: {
        conversation: null,
        visible: false,
        x: null,
        y: null,
      },
    };
  },
  created() {
    //隐藏Conversation右键菜单
    document.addEventListener('click', () => {
      this.hideRightClickMenu();
    });
    this.getGroupList(0)
  },
  beforeDestroy() {
    this.goEasy.im.off(this.GoEasy.IM_EVENT.CONVERSATIONS_UPDATED, this.renderConversations);
  },
  methods: {
    formatDate,
    getGroupList(patientType) {
      restApi.getGroups(patientType).then(({ data: { message, data } }) => {
        if (message && data?.length) {
          console.log("group-data", data)
          this.groups = data;
          this.listenConversationUpdate(); //监听会话列表变化
          this.loadConversations(); //加载会话列表
          this.subscribeGroup();  //订阅群消息
          this.showEmpty = false;
        } else {
          this.groups = [];
          this.showEmpty = true;
        }
      });
      this.active = patientType;
    },
    loadConversations() {
      this.goEasy.im.latestConversations({
        onSuccess: (result) => {
          let content = result.content;
          console.log("content", content)
          this.renderConversations(content);
        },
        onFailed: (error) => {
          console.log('获取最新会话列表失败, code:' + error.code + 'content:' + error.content);
        },
      });
    },
    listenConversationUpdate() {
      // 监听会话列表变化
      this.goEasy.im.on(this.GoEasy.IM_EVENT.CONVERSATIONS_UPDATED, this.renderConversations);
    },
    renderConversations(content) {
      console.log("content--1", content, this.groups)
      this.conversations = content.conversations;
      this.conversationIds = content.conversations.map(item => item.groupId);
      let newGroups = content.unreadTotal ? this.groups.map(group => {
        const index = this.conversationIds.indexOf(group.id);
        if (index > -1) {
          let conversation = content.conversations[index];
          // console.log("find-conversation",index,conversation)
          return {
            ...group,
            unread: conversation.unread
          }
        } else {
          return { ...group }
        }
      }) : false
      // console.log("newGroups",newGroups);
      this.groups = newGroups ? newGroups : this.groups;
    },
    subscribeGroup() {
      let groups = this.groups;
      let groupIds = groups.map((item) => item.id);
      this.goEasy.im.subscribeGroup({
        groupIds: groupIds,
        onSuccess: function () {
          console.log('订阅群消息成功');
        },
        onFailed: function (error) {
          console.log('订阅群消息失败:', error);
        },
      });
    },
    showRightClickMenu(e, conversation) {
      this.rightClickMenu.conversation = conversation;
      this.rightClickMenu.visible = true;
      this.rightClickMenu.x = e.pageX;
      this.rightClickMenu.y = e.pageY;
    },
    hideRightClickMenu() {
      this.rightClickMenu.visible = false;
    },
    topConversation() {
      let conversation = this.rightClickMenu.conversation;
      let description = conversation.top ? '取消置顶' : '置顶';
      this.goEasy.im.topConversation({
        conversation: conversation,
        top: !conversation.top,
        onSuccess: function () {
          console.log(description, '成功');
        },
        onFailed: function (error) {
          console.log(description, '失败：', error);
        },
      });
    },
    deleteConversation() {
      if (confirm('确认要删除这条会话吗？')) {
        let conversation = this.rightClickMenu.conversation;
        this.goEasy.im.removeConversation({
          conversation: conversation,
          onSuccess: function () {
            console.log('删除会话成功');
          },
          onFailed: function (error) {
            console.log(error);
          },
        });
      }
    },
    groupChat(group, i) {
      this.currentGroup = null
      restApi.currentGroup = false;
      setTimeout(() => {
        this.groups[i] = {
          ...group,
          unread: 0
        }
        this.currentGroup = {
          ...group,
          unread: 0
        };
        restApi.currentGroup = group;
      }, 0);
    }
  },
};
</script>

<style scoped>
.conversations {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  color: #333333;
}

.group-type-box {
  height: 40px;
  align-items: center;
  display: flex;
  justify-content: space-around;
  padding: 0 10px;
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  background-color: #6495ed12;

}
.group-type-box div{
  cursor: pointer;
}
.group-type-box .active {
  color: cornflowerblue;
}

.contact-left {
  width: 240px;
  height: 100%;
  overflow: auto;
  border-right: #dbd6d6 1px solid;
}

.contact-list-title {
  margin: 10px 20px;
  font-size: 14px;
}

.group-list {
  display: flex;
  flex-direction: column;
}

.group-item {
  position: relative;
  display: flex;
  padding: 5px 10px;
  cursor: pointer;
  align-items: center;
}

.group-avatar {
  width: 40px;
  height: 40px;
  margin-left: 10px;
}

.unread-count {
  position: absolute;
  top: 0px;
  left: 50px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: white;
  background: #d02129;
}

.group-avatar img {
  width: 40px;
  height: 40px;
}

.group-name {
  margin-left: 10px;
  width: 160px;
  text-align: left;
  font-size: 14px;
  line-height: 40px;
}

.actived {
  background: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
}

.conversation-list {
  width: 220px;
}

.conversation-list-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-right: #dbd6d6 1px solid;
}

.conversation-list-content {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.conversation-list-content::-webkit-scrollbar {
  display: none;
}

.no-conversation {
  text-align: center;
  color: #666666;
}

.conversation {
  display: flex;
  padding: 10px 5px;
  cursor: pointer;
}



.unread-count .unread {
  display: block;
  font-size: 12px;
  text-align: center;
  line-height: 18px;
}

.conversation-message {
  flex: 1;
  padding-left: 5px;
  display: flex;
  width: 160px;
  flex-direction: column;
  justify-content: space-around;
}

.conversation-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: right;
}

.conversation-name {
  font-size: 12px;
  font-weight: 500;
}

.conversation-time {
  width: 75px;
  color: #B9B9B9;
  display: flex;
  flex-direction: column;
}

.conversation-bottom {
  display: flex;
  color: #666666;
}

.conversation-content {
  display: flex;
  width: 160px;
  color: #b3b3b3;
}

.conversation-content .text {
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  white-space: nowrap;
  word-break: break-all;
}

.conversation-bottom .unread-text {
  color: #d02129;
  width: 35px !important;
}

.conversation .avatar {
  width: 40px;
  height: 40px;
  position: relative;
}

.conversation .avatar img {
  width: 100%;
  border-radius: 10%;
}

.router-link-active {
  background: #eeeeee;
}

.action-box {
  width: 100px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #cccccc;
  position: fixed;
  z-index: 100;
  border-radius: 5px;
}

.action-box .action-item {
  padding-left: 15px;
  line-height: 30px;
  font-size: 13px;
  color: #262628;
  cursor: pointer;
}

.action-box .action-item:hover {
  background: #dddddd;
}

.chat {
  flex: 1;
  display: flex;
}

.empty-box {
  width: 100%;
  padding-top: 100px;
  text-align: center;
  font-size: 30px;

}
</style>
